/* eslint-disable react/jsx-no-useless-fragment */
import { Document, Page, Text, View, Image, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import { Fragment, PureComponent } from 'react';
import logo from './../../assets/images/invoice-logo.png';
import logo2 from './../../assets/images/invoice-logo-2.png';
import footer from './../../assets/images/footer.png';
import { Container } from 'shards-react';
import moment from 'moment';

class ContractInvoicePdf extends PureComponent {
  constructor(props) {
    super(props);

    this.setStateFromLink = this.setStateFromLink.bind(this);

    this.state = {
      ready: true,
      contract: { establishment: { name: 'contract name' } },
    };
  }
  setStateFromLink(state) {
    if (state) {
      const { contract } = state;
      this.setState({ contract });
    }
  }

  componentDidMount() {
    if (!(this.props.location.params && this.props.location.params.contract)) {
      this.props.history.push('/contract');
    } else {
      this.setStateFromLink({ contract: this.props.location.params.contract });

      this.setState({ ready: false });
      setTimeout(() => {
        this.setState({ ready: true });
      }, 1);
    }
  }
  render() {
    const styles = StyleSheet.create({
      page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft: 60,
        paddingRight: 60,
        lineHeight: 1.5,
        flexDirection: 'column',
      },
      logo: {
        width: '300px',
        height: '100px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 20,
      },

      logo2: {
        width: '100px',
        height: '50px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 20,
      },
      titleContainer: {
        flexDirection: 'row',
        marginTop: 24,
        border: '1 solid #72a23e',
        backgroundColor: '#72a23e',
        padding: '15px',
        borderRadius: '10',
        marginBottom: '30px',
      },
      reportTitle: {
        fontWeight: '900',
        fontSize: 15,
        textAlign: 'center',
        textTransform: 'uppercase',
      },

      row: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
        marginBottom: '10px',
      },
      key: {
        width: '20%',
        textAlign: 'left',
        paddingLeft: 8,
      },

      director: {
        marginTop: 100,
        width: '50%',
        textAlign: 'left',
        paddingLeft: 80,
      },
      value: {
        width: '75%',
        height: '30px',
        paddingTop: '7px',
        border: '1 solid gray',
        paddingLeft: '5px',
      },
      footer: {
        width: '100%',
        bottom: '0',
      },
    });
    if (this.state.ready) {
      return (
        <Container>
          <PDFViewer width="1000" height="800">
            <Fragment>
              <Document>
                <Page size="A4" style={styles.page}>
                  <Image style={styles.logo} src={logo} />

                  <View style={styles.titleContainer}>
                    <View style={styles.reportTitle}>
                      <Text>FORMULAIRE D'ABONNEMENT À LA BIBLIOTHÈQUE NUMÉRIQUE - UDL</Text>
                    </View>
                  </View>

                  <Image style={styles.logo2} src={logo2} />

                  <View style={styles.row}>
                    <Text style={styles.key}>Etablissement</Text>
                    <Text style={styles.value}>{this.state.contract.establishment.name}</Text>
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.key}>Téléphone</Text>
                    <Text style={styles.value}>{this.state.contract.establishment.phone}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.key}>Email</Text>
                    <Text style={styles.value}>{this.state.contract.establishment.email}</Text>
                  </View>

                  {/* <View style={styles.row}>
                    <Text style={styles.key}>Fax</Text>
                    <Text style={styles.value}></Text>
                  </View> */}

                  <View style={styles.row}>
                    <Text style={styles.key}>Date de début</Text>
                    <Text style={styles.value}>{moment(this.state.contract.contractStartDate).format('YYYY-MM-DD')}</Text>
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.key}>Date de fin</Text>
                    <Text style={styles.value}>{moment(this.state.contract.contractEndDate).format('YYYY-MM-DD')}</Text>
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.director}>Représentant de l’OPU</Text>
                    <Text style={styles.director}>Etablissement</Text>
                  </View>

                  <View style={styles.row}></View>
                  <View style={styles.row}></View>
                  <View style={styles.row}></View>
                  <View style={styles.row}></View>
                  <View style={styles.row}></View>
                  <View style={styles.row}></View>

                  <Image style={styles.footer} src={footer} />
                </Page>
              </Document>
            </Fragment>
          </PDFViewer>
        </Container>
      );
    } else return null;
  }
}
export default ContractInvoicePdf;
